    <mat-card class="wide-form-card center f-nunito">
      <mat-card-content [innerHtml]="content" >
      </mat-card-content>
    </mat-card>
